import styled from 'styled-components';

export const StyledCirclePicker = styled.div`
  div span div span div {
    border: 2px solid #e8e8e8;
  }
`;
